export const EXPAND_COLUMN = {};
export const INTERNAL_HOOKS = 'rc-table-internal-hook';